import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import garbage from "../../../assets/images/garbage.svg";
import { folderService } from "services/folder.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function DeleteAlert(props) {
  const { show, handleClose, folderId, data, setData } = props;
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      const response = await folderService.deletefolder(folderId);
      handleClose();
      if (response?.data?.success) {
        toast.success(response?.data?.message, { autoClose: 2000 });
        const newFolders = data?.folders.filter((folder) => folder._id !== folderId);
        setData({
          totalFolders: newFolders?.length,
          folders: newFolders,
        });
        navigate("/my-files");
      } else {
        toast.warning(response?.data?.message, { autoClose: 4000 });
      }
    } catch (err) {
      console.error(err?.response?.data?.message);
      setError(err?.response?.data?.message);
    }
  };

  return (
    <>
      <Modal show={show} className="modal-common delete-pop" onHide={handleClose}>
        <Modal.Body>
          <div className="text-center">
            <div className="garbage-box d-flex justify-content-center align-items-center">
              <img alt="" src={garbage} />
            </div>
            <h2 className="mb-3">Delete Folder</h2>
            <p>Are you sure you want to delete this folder?</p>
            <div className="d-flex flex-wrap gap-2 mt-4">
              <button className="btn blue-btn" onClick={handleClose}>
                No
              </button>
              <button className="btn gray-btn" onClick={handleDelete}>
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DeleteAlert;
